import {Component, forwardRef} from '@angular/core';
import {DictionariesService} from "../../../service";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ViewDictionaryBase} from "../view-dictionary-base";
import {PageObl} from "../../../../../../api/build";

@Component({
  selector: 'app-dict-qref-okato-by-obl',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QrefOkatoByOblViewComponent),
    multi: true
  }],
  template: `
    <div>
      <label class="form-label">{{title}}
        <app-rq *ngIf="isFieldReq(formControl)" [isReadOnly]="isDisabled"></app-rq>
      </label>
      <app-custom-select *ngIf="dictionary | async as dict; else loading"
                         code="okato"
                         name="name"
                         [items]="dict"
                         [returnOnlyId]="true"
                         [formControl]="formControl"
                         [fieldsFromSearch]="['code','name']"
                         [isInvalid]="submitted && formControl.errors">
        <ng-template let-item #labelTemplate>
        <b> {{ item.code }} </b>
          {{ item.name }}
        </ng-template>
        <ng-template let-item let-search="search" #optionTemplate>
        <b> {{ item.code }} </b>
          {{ item.name }}
        </ng-template>
      </app-custom-select>
      <ng-template #loading>
        ...загрузка
      </ng-template>
      <app-valid [logic]="formControl" [submitted]="submitted"></app-valid>
    </div>
  `
})
export class QrefOkatoByOblViewComponent extends ViewDictionaryBase<PageObl> {
  getDictionary = this.dictSrv.getQrefOblList();
  constructor(private dictSrv: DictionariesService) {
    super();
  }

  fillByRegionCode(code: string){
    this.dictionary.subscribe(data => {
      const item = data.find(item => item.code == code);
      this.formControl.setValue(item?.okato);
    })
  }
}
